import { useEffect, useState, useCallback } from 'react'
import bext, { listenToExtension } from 'utils/bext'
import toast from 'react-hot-toast'
import { useRecoilState, isExtInstalledIdxCounterAtom } from 'lib/recoil'

export const useIsExtensionConnected = (uid) => {
  const [connected, setConnected] = useState(null)
  const [idx, setIdx] = useRecoilState(isExtInstalledIdxCounterAtom)

  const incrementIdx = useCallback(
    () => setIdx((oldValue) => oldValue + 1),
    [setIdx],
  )

  useEffect(() => {
    if (!uid) return
    bext.isExtensionInstalled().then((installedInfo) => {
      if (installedInfo?.uid) {
        if (installedInfo.uid === uid) {
          setConnected(installedInfo)
        } else {
          setConnected(false)
          toast.error(
            <p>
              FYI since you're logged in <b>as different users</b> here vs. in
              the browser extension, code will pretend the extension isn't
              installed at all.
            </p>,
            { id: 'web-ext-auth-mismatch', duration: 6000 },
          )
        }
      } else if (installedInfo?.version) {
        setConnected(true)
      } else {
        setConnected(false)
      }
    })
  }, [uid, idx])

  return { connectedInfo: connected, refreshFn: incrementIdx }
}

const useWithConnectedExtension = (uid, callback) => {
  const isConnected = useIsExtensionConnected(uid)

  // Note NOTE depending on given callback - will memoize first passed in, do not change
  const ifInstalledFn = useCallback(
    () => isConnected && callback(),
    [isConnected],
  )
  useEffect(ifInstalledFn, [isConnected])
}
export const useExtensionListener = (uid, actionName, callback) => {
  // listenToExtension returns the unsub function to useEffect, so will handle unsubscribing when component is unmounted
  useWithConnectedExtension(
    uid,
    () => listenToExtension(actionName, callback),
    [uid, actionName, callback],
  )
}
